import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { lang } = useParams<{ lang: string }>();

  const switchLanguage = (newLang: string) => {
    const newPath = location.pathname.replace(`/${lang}`, `/${newLang}`);
    i18n.changeLanguage(newLang);
    navigate(newPath);
  };

  return (
    <div className="flex space-x-1">
      <button
        onClick={() => switchLanguage('el')}
        className={`px-3 py-1 rounded text-sm font-medium transition-colors ${
          lang === 'el'
            ? 'bg-white text-blue-600'
            : 'bg-blue-700 text-white hover:bg-blue-500'
        }`}
        aria-label="Ελληνικά"
      >
        EL
      </button>
      <button
        onClick={() => switchLanguage('en')}
        className={`px-3 py-1 rounded text-sm font-medium transition-colors ${
          lang === 'en'
            ? 'bg-white text-blue-600'
            : 'bg-blue-700 text-white hover:bg-blue-500'
        }`}
        aria-label="English"
      >
        EN
      </button>
    </div>
  );
}
